<template>
  <div id="form-tour">
    <h2>
      <span v-if="editingMode === 'edit'">Editar</span>
      <span v-if="editingMode === 'create'">Novo</span> Percurso
    </h2>
    <br />
    <b-container>
      <b-row>
        <b-col sm="2">
          <b-input-group>
            <b-input-group-prepend is-text>
              <b-form-checkbox
                id="checkbox-premium"
                v-model="editingCache.premium"
                name="checkbox-premium"
                type="checkbox"
                aria-label="Checkbox for following text input"
                :disabled="disabledInputs"
              />
            </b-input-group-prepend>
            <b-form-input disabled placeholder="Premium" aria-label="Text input with checkbox"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col sm="2">
          <b-input-group>
            <b-input-group-prepend is-text>
              <b-form-checkbox
                id="checkbox-exclusive"
                v-model="editingCache.isExclusive"
                name="checkbox-exclusive"
                inline
                :disabled="disabledInputs"
              />
            </b-input-group-prepend>
            <b-form-input disabled placeholder="Exclusivo" aria-label="Text input with checkbox"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col sm="2">
          <b-input-group>
            <b-input-group-prepend is-text>
              <b-form-checkbox
                id="checkbox-feet"
                v-model="editingCache.percursoFeet"
                name="checkbox-feet"
                readonly
                :disabled="disabledInputs"
              />
            </b-input-group-prepend>
            <b-form-input disabled placeholder="A pe" aria-label="Text input with checkbox"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col sm="2">
          <b-input-group>
            <b-input-group-prepend is-text>
              <b-form-checkbox
                id="checkbox-bike"
                v-model="editingCache.percursoBike"
                name="checkbox-bike"
                inline
                :disabled="disabledInputs"
              />
            </b-input-group-prepend>
            <b-form-input disabled placeholder="Bike" aria-label="Text input with checkbox"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col sm="2">
          <b-input-group>
            <b-input-group-prepend is-text>
              <b-form-checkbox
                id="checkbox-car"
                v-model="editingCache.percursoCar"
                name="checkbox-car"
                inline
                :disabled="disabledInputs"
              />
            </b-input-group-prepend>
            <b-form-input disabled placeholder="Carro" aria-label="Text input with checkbox"></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="4">
          <b-input-group prepend="Dificuldade" size="sm" class="mt-4">
            <b-form-input
              v-model="editingCache.difficulty"
              v-validate.initial="'required|numeric|min_value:1|max_value:4'"
              type="range"
              min="1"
              max="4"
              name="difficulty"
              size="sm"
              :disabled="disabledInputs"
            />
            <div class="mt-2">&nbsp; {{ editingCache.difficulty }}</div>
          </b-input-group>
          <b-form-invalid-feedback
            :state="errors.collect('difficulty').length === 0"
          >{{errors.first('difficulty')}}</b-form-invalid-feedback>
        </b-col>
        <b-col sm="4">
          <b-input-group prepend="Nr Recom. Pessoas" size="sm" class="mt-4">
            <b-form-input
              v-model="editingCache.pax"
              v-validate.initial="'required|numeric'"
              type="number"
              name="pax"
              size="sm"
              :disabled="disabledInputs"
            />
          </b-input-group>
          <b-form-invalid-feedback
            :state="errors.collect('pax').length === 0"
          >{{errors.first('pax')}}</b-form-invalid-feedback>
        </b-col>
        <b-col sm="4">
          <b-input-group prepend="Nr Max. Pessoas" size="sm" class="mt-4">
            <b-form-input
              v-model="editingCache.paxMax"
              v-validate.initial="'required|numeric'"
              type="number"
              name="paxMax"
              size="sm"
              :disabled="disabledInputs"
            />
          </b-input-group>
          <b-form-invalid-feedback
            :state="errors.collect('paxMax').length === 0"
          >{{errors.first('paxMax')}}</b-form-invalid-feedback>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="4">
          <b-input-group prepend="Tempo" size="sm" class="mt-4">
            <b-form-input
              v-model="editingCache.timeWasted"
              v-validate.initial="'required'"
              type="text"
              name="timeWasted"
              size="sm"
              placeholder="ex:2h/2h30m"
              :disabled="disabledInputs"
            />
          </b-input-group>
          <b-form-invalid-feedback
            :state="errors.collect('timeWasted').length === 0"
          >{{errors.first('timeWasted')}}</b-form-invalid-feedback>
        </b-col>
        <b-col sm="4">
          <b-input-group prepend="Mes" size="sm" class="mt-4">
            <b-form-input
              v-model="editingCache.mesEvento"
              v-validate.initial="'required|numeric|min_value:1|max_value:12'"
              type="range"
              min="1"
              max="12"
              name="mesEvento"
              size="sm"
              placeholder="0 - 12"
              :disabled="disabledInputs"
            />
            <div class="mt-2">&nbsp; {{ editingCache.mesEvento }}</div>
          </b-input-group>
          <b-form-invalid-feedback
            :state="errors.collect('mesEvento').length === 0"
          >{{errors.first('mesEvento')}}</b-form-invalid-feedback>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="4">
          <b-input-group prepend="Idiomas" size="sm" class="mt-4">
            <b-form-input
              v-model="editingCache.idiomas"
              v-validate.initial="'required|max:50'"
              type="text"
              name="idiomas"
              size="sm"
              :disabled="disabledInputs"
            />
          </b-input-group>
          <b-form-invalid-feedback
            :state="errors.collect('idiomas').length === 0"
          >{{errors.first('idiomas')}}</b-form-invalid-feedback>
        </b-col>
        <b-col sm="4">
          <b-input-group prepend="Preço" size="sm" class="mt-4">
            <b-form-input
              v-model="editingCache.preco"
              v-validate.initial="'required|max:12'"
              type="text"
              name="preco"
              size="sm"
              placeholder="10€"
              :disabled="disabledInputs"
            />
          </b-input-group>
          <b-form-invalid-feedback
            :state="errors.collect('preco').length === 0"
          >{{errors.first('preco')}}</b-form-invalid-feedback>
        </b-col>
        <b-col sm="4">
          <b-input-group prepend="Preço Conjunto" size="sm" class="mt-4">
            <b-form-input
              v-model="editingCache.precoConjunto"
              v-validate.initial="'required'"
              type="text"
              name="precoConjunto"
              size="sm"
              :disabled="disabledInputs"
            />
          </b-input-group>
          <b-form-invalid-feedback
            :state="errors.collect('precoConjunto').length === 0"
          >{{errors.first('precoConjunto')}}</b-form-invalid-feedback>
        </b-col>
        <b-col sm="4">
          <b-input-group prepend="mais Info" size="sm" class="mt-4">
            <b-form-input
              v-model="editingCache.maisInfo"
              v-validate.initial="'required|max:30'"
              type="text"
              name="maisInfo"
              size="sm"
              :disabled="disabledInputs"
            />
          </b-input-group>
          <b-form-invalid-feedback
            :state="errors.collect('maisInfo').length === 0"
          >{{errors.first('maisInfo')}}</b-form-invalid-feedback>
        </b-col>
        <b-col>
          <b-input-group prepend="Imagem" size="sm" class="mt-4">
            <b-input
              v-model="editingCache.image"
              v-validate.initial="'required'"
              name="image"
              :disabled="disabledInputs"
            ></b-input>
          </b-input-group>
          <b-form-invalid-feedback
            :state="errors.collect('image').length === 0"
          >{{errors.first('image')}}</b-form-invalid-feedback>
        </b-col>
      </b-row>
      <b-row>
        <b-tabs class="mt-4 w-100">
          <!-- 
			When we have an API this should be dynamic 
			instead of being static.
          -->
          <b-tab title="Português">
            <translations-tour
              v-bind.sync="editingCache"
              :disabledInputs="disabledInputs"
              language="pt"
            />
          </b-tab>
          <b-tab title="Inglês">
            <translations-tour
              v-bind.sync="editingCache"
              :disabledInputs="disabledInputs"
              language="en"
            />
          </b-tab>
          <b-tab title="Francês">
            <translations-tour
              v-bind.sync="editingCache"
              v-bind:tempMarkDesc.sync="tempMarkDesc"
              v-bind:tempMarkName.sync="tempMarkName"
              v-bind:preMarkList.sync="preMarkList"
              @moveUp="key => moveMark(key, 'up')"
              @moveDown="key => moveMark(key, 'down')"
              @removeMark="key => removeMark(key)"
              :disabledInputs="disabledInputs"
              language="fr"
            />
          </b-tab>
          <b-tab title="Espanhol">
            <translations-tour
              v-bind.sync="editingCache"
              :disabledInputs="disabledInputs"
              language="es"
            />
          </b-tab>
        </b-tabs>
      </b-row>
    </b-container>
    <br />
    <div v-if="editingMode !== 'view'">
      <b-button
        variant="primary"
        @click="editingMode === 'edit' ? updateTour(editingCache.id) : createTour()"
        :disabled="errors.count() > 0 || tempStage === 0"
      >Submeter</b-button>
    </div>
  </div>
</template>

<script>
import api from "../../api";
import { mapMutations, mapActions } from "vuex";
import translationsTour from "./translationsTour";

export default {
  name: "formTour",
  props: {
    editingMode: { type: String, required: true },
    tour: { type: Object }
  },
  components: {
    translationsTour
  },
  data() {
    return {
      preIncludes: [],
      preMarkList: [],
      tempMarkName: "",
      tempMarkDesc: "",
      tempStage: 0,
      editingCache: {
        premium: false,
        percursoFeet: false,
        percursoBike: false,
        percursoCar: false,
        isExclusive: false,
        timeWasted: "",
        mesEvento: 1,
        difficulty: 1,
        pax: "",
        paxMax: "",
        inclui: "",
        idiomas: "",
        preco: "",
        precoConjunto: "",
        maisInfo: "",
        title: "",
        strongDesc: "",
        description: "",
        precoConjunto: "",
        image: "",
        markList: {},
        translations: {
          pt: {
            title: "",
            description: "",
            strongDesc: ""
          },
          en: {
            title: "",
            description: "",
            strongDesc: ""
          },
          fr: {
            title: "",
            description: "",
            strongDesc: ""
          },
          es: {
            title: "",
            description: "",
            strongDesc: ""
          }
        }
      }
    };
  },
  computed: {
    hasNoIncludes() {
      return this.preIncludes.length === 0;
    },
    hasNoMarks() {
      return this.tempStage === 0;
    },
    disabledInputs() {
      return this.editingMode === "view";
    }
  },
  mounted() {
    if (this.editingMode !== "create") {
      this.editingCache = JSON.parse(JSON.stringify(this.tour));
      this.preMarkList = Object.keys(this.editingCache.markList).map(key => {
        return this.editingCache.markList[key];
      });
      this.translations = { ...this.tour.translations };
      this.tempStage = this.preMarkList.length;
    }
  },
  methods: {
    ...mapMutations(["showNotice"]),
    ...mapActions(["refreshTours"]),
    createTour() {
      this.tempStage = 0;
      this.editingCache.markList = { ...this.preMarkList };
      api.newTour(this.editingCache).then(response => {
        this.refreshTours();
        this.showNotice({ newMessage: "Percurso criado", type: "success" });
        this.editingCache.markList = {};
        this.editingCache.inclui = "";
      });
    },
    updateTour(id) {
      this.editingCache.markList = { ...this.preMarkList };
      api.updateTour({ id }, this.editingCache).then(response => {
        this.refreshTours();
        this.showNotice({ newMessage: "Percurso atualizado", type: "success" });
      });
    },
    addMark() {
      if (this.tempMarkName !== "") {
        this.preMarkList.push({
          theme: this.tempMarkName,
          themeDesc: this.tempMarkDesc
        });
        this.tempStage++;
      }
    },
    removeMark(key) {
      this.$delete(this.preMarkList, key);
      const temp = Object.keys(this.preMarkList).length;
      if (temp === 0) this.tempStage = 0;
    },
    moveMark(keyOrigin, direction) {
      let keyDestiny = undefined;
      if (direction === "up") {
        keyDestiny = keyOrigin - 1;
      }
      if (direction === "down") {
        keyDestiny = keyOrigin + 1;
      }
      const tempOrigin = this.preMarkList[keyOrigin];
      const tempDestiny = this.preMarkList[keyDestiny];
      this.$set(this.preMarkList, keyDestiny, tempOrigin);
      this.$set(this.preMarkList, keyOrigin, tempDestiny);
    }
  }
};
</script>

<style lang='css'>
#new-tour {
  color: #56b983;
}
#new-tour label {
  text-align: left;
}
.errors-list {
  color: red;
  list-style-type: none;
}
</style>

